import React, { useState } from 'react';
import { Descriptions, Tag, Typography, Space, Switch } from 'antd';
import { User } from '../../../models';
import moment from 'moment';
import { apiClient, apiErrorMessage } from '../../../utils';

export function UserDetailsForm(props: { user?: User; onUserUpdated?: () => void }) {
  const { Text } = Typography;
  const [loading, setLoading] = useState(false);

  if (!props.user) {
    return <Text type="secondary">Kullanıcı bilgisi bulunamadı</Text>;
  }

  const { user } = props;

  const updateUserReceiveEmails = (receiveEmails: boolean) => {
    setLoading(true);
    apiClient
      .put(`users/${user.id}/email-notifications`, { receiveEmails })
      .then(() => {
        if (props.onUserUpdated) {
          props.onUserUpdated();
        }
      })
      .catch((reason: any) => {
        apiErrorMessage(reason);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Descriptions bordered column={1}>
      <Descriptions.Item label="İsim">
        <Text strong>{user.fullName}</Text>
      </Descriptions.Item>
      <Descriptions.Item label="No">{user.employeeNumber || '-'}</Descriptions.Item>
      <Descriptions.Item label="E-posta">
        <a href={`mailto:${user.email}`}>{user.email}</a>
      </Descriptions.Item>
      <Descriptions.Item label="Bölüm">{user.department || '-'}</Descriptions.Item>
      <Descriptions.Item label="Ünvan">{user.title || '-'}</Descriptions.Item>
      <Descriptions.Item label="Roller">
        <Space wrap>
          {user.roles?.map(role => (
            <Tag key={role.id || 'superadmin'} color={role.name === 'Superadmin' ? 'red' : 'default'}>
              {role.name}
            </Tag>
          ))}
          {user.delegatedRoles?.map(role => (
            <Tag key={role.id} color="blue">
              {role.name}
            </Tag>
          ))}
          {(!user.roles?.length && !user.delegatedRoles?.length) && '-'}
        </Space>
      </Descriptions.Item>
      <Descriptions.Item label="Son giriş">
        {user.lastLoginAt ? moment(user.lastLoginAt).format('DD.MM.yyyy HH:mm:ss') : '-'}
      </Descriptions.Item>
      <Descriptions.Item label="E-posta bildirimleri">
        <Switch
          checked={user.receiveEmails}
          onChange={() => updateUserReceiveEmails(!user.receiveEmails)}
          loading={loading}
        />
      </Descriptions.Item>
    </Descriptions>
  );
}
